export const MAP_STREET_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export const MAP_STREET_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>';

export const MAP_SATELLITE_TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export const MAP_SATELLITE_ATTRIBUTION =
  'Imagery &copy; <a href="https://www.esri.com" target="_blank" rel="noreferrer">Esri</a>';

export const MAP_SATELLITE_LABELS_TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}';

export const MAP_CLOSE_UP_ZOOM = 16;

export const MAP_MAX_TILE_ZOOM = 18;

export const MAP_LARGE_LABEL_ZOOM_SHIFT = 1;

export const MAP_LARGE_LABEL_MAX_ZOOM = MAP_MAX_TILE_ZOOM + MAP_LARGE_LABEL_ZOOM_SHIFT;

export const MAP_LARGE_LABEL_CLOSE_UP_ZOOM = MAP_CLOSE_UP_ZOOM + MAP_LARGE_LABEL_ZOOM_SHIFT;

export const MAP_SINGLE_POINT_ZOOM = 13;

export const MAP_VIEW_FLY_DURATION_SECONDS = 0.8;

export const MAP_MIN_ZOOM = 6;

export const MAP_PAN_LIMIT_BOUNDS: [[number, number], [number, number]] = [
  [20.3, 87.8],
  [26.9, 92.9],
];

export const MAP_COUNTRY_FIT_PADDING: [number, number] = [8, 8];
